export default {"src":"https://assets.ctr1.net/d1a32bdc1f09/_next/static/media/onelogin.a1caacfd.svg","height":250,"width":250,"blurWidth":0,"blurHeight":0};